import { useSelector } from "react-redux";

import {
  useDeleteAccountMutation,
  useForgotPasswordMutation,
  useLazyPrivacyPolicyQuery,
  useLazyTermsAndConditionsQuery,
  useLoginMutation,
  useLogoutMutation,
  useResetPassMutation,
  useSendOtpMutation,
  useVerifyDeleteAccountMutation,
  useVerifyOtpMutation,
} from "store/api/auth";
import { fixedCacheKeys } from "utils/fixedCacheKeys";

export const useAuthHook = () => {
  /** ***************** 
  @purpose : Used For handle get and reset data
  @Parameter : {data,reset}
  @Author : INIC
  ***************** */

  const [login, { data, isLoading, reset: resetLoginDetails }] =
    useLoginMutation({
      fixedCacheKey: fixedCacheKeys.LOGIN,
    });

  const [
    sendOtp,
    { data: otpDetails, reset: resetOtpDetails, isLoading: sendOtpLoading },
  ] = useSendOtpMutation({
    fixedCacheKey: fixedCacheKeys.SEND_OTP,
  });

  const [
    verifyOtp,
    {
      data: verificationData,
      reset: resetOtpVerification,
      isLoading: verifyLoading,
    },
  ] = useVerifyOtpMutation({
    fixedCacheKey: fixedCacheKeys.VERIFY_OTP,
  });

  const [logoutUser, { reset: resetLogoutData }] = useLogoutMutation({
    fixedCacheKey: fixedCacheKeys.LOGOUT,
  });

  const [forgotPassword, { isLoading: forgotPassLoading }] =
    useForgotPasswordMutation({
      fixedCacheKey: fixedCacheKeys.FORGOT_PASSWORD,
    });

  const [resetPass, { isLoading: resetPassLoading, reset: resetPassword }] =
    useResetPassMutation({
      fixedCacheKey: fixedCacheKeys.RESET_PASSWORD,
    });

  const [deleteAccount, { isLoading: deleteAccountLoading }] =
    useDeleteAccountMutation({
      fixedCacheKey: fixedCacheKeys.DELETE_ACCOUNT,
    });

  const [verifyDeleteAccount] = useVerifyDeleteAccountMutation({
    fixedCacheKey: fixedCacheKeys.VERIFY_DELETE_ACCOUNT,
  });

  const [fetchPrivacyPolicy, privacyPolicyLazyResult] =
    useLazyPrivacyPolicyQuery({
      fixedCacheKey: fixedCacheKeys.PRIVACY_POLICY,
    });

  const [fetchTermsAndConditions, termsAndConditionsLazyResult] =
    useLazyTermsAndConditionsQuery({
      fixedCacheKey: fixedCacheKeys.TERMS_AND_CONDITIONS,
    });

  const access_token = useSelector((state) => state.token.access_token);
  const resetAuthData = () => {
    resetLoginDetails();
    resetOtpDetails();
    resetOtpVerification();
    resetPassword();
  };

  return {
    login,
    data,
    isLoading,
    otpDetails,
    sendOtp,
    sendOtpLoading,
    verifyOtp,
    verificationData,
    access_token,
    resetOtpDetails,
    resetLoginDetails,
    resetOtpVerification,
    verifyLoading,
    logoutUser,
    forgotPassword,
    forgotPassLoading,
    resetPass,
    resetPassLoading,
    resetAuthData,
    resetLogoutData,
    deleteAccount,
    deleteAccountLoading,
    verifyDeleteAccount,
    fetchPrivacyPolicy,
    privacyPolicyLazyResult,
    fetchTermsAndConditions,
    termsAndConditionsLazyResult,
  };
};
